import { compose } from 'redux';
import { connect } from 'react-redux';
import subscriptionDecorator from 'subscriptions/decorator';
import * as routes from 'app/routes';

import {
  getCurrentBypassedPlan,
  getUpcomingBypassedPlan,
  getAllBypassedPlans,
  getOverduePurchases,
  getUser,
} from 'reducers';

import {
  fetchAll as fetchAllPlans,
  findUpcoming as findUpcomingPlan
} from 'subscriptions/plans/bypassed/actions';

import { fetchFiltered as fetchFilteredPurchases } from 'billing/purchases/actions';

import { createBypassedUpgrade as createUpgradePurchase } from 'billing/purchases/actions';
import AddDataPicker from './AddDataPicker';


const mapStateToProps = (state, { subId }) => ({
  upcomingPlan: getUpcomingBypassedPlan(state, subId),
  currentPlan: getCurrentBypassedPlan(state, subId),
  allPlans: getAllBypassedPlans(state),
  overduePurchases: getOverduePurchases(state),
  user: getUser(state),
});

const mapDispatchToProps = {
  fetchAllPlans,
  findUpcomingPlan,
  createUpgradePurchase,
  purchaseRoute: routes.bypassedAddDataPurchase,
  fetchFilteredPurchases,
}

export default compose(
  subscriptionDecorator,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(AddDataPicker);
